import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Row, Col, ProgressBar } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation } from '@apollo/client';
import { SEGMENT_TREE } from 'graphql/mlmodel';
import { setTaskModalDialogVisible } from 'reducers/viewListingReducer';

const TaskModal = ({ refetchTreeSegmentation }) => {
  const dispatch = useDispatch();
  const { taskModalDialogVisible, unsegmentedTiles } = useSelector(
    state => state.viewListing
  );
  const { mapboxSatelliteV9URL } = useSelector(state => state.config);
  const [progress, setProgress] = useState(0);
  const [maxProgress, setMaxProgress] = useState(0);
  const [segmentTileMutation] = useMutation(SEGMENT_TREE);

  useEffect(() => {
    (async () => {
      if (unsegmentedTiles.length === 0) {
        dispatch(setTaskModalDialogVisible(false));
        return;
      }
      setMaxProgress(unsegmentedTiles.length);
      let progress = 0;
      for (const tile of unsegmentedTiles) {
        const [zoom, x, y] = tile;
        const tileImageUrl = mapboxSatelliteV9URL
          .replace('{z}', zoom)
          .replace('{x}', x)
          .replace('{y}', y);

        const response = await fetch(tileImageUrl);
        const blob = await response.blob();
        const file = new File([blob], `${zoom}_${x}_${y}.jpg`, {
          type: blob.type
        });
        await segmentTileMutation({
          variables: {
            tileImage: file,
            zoom: zoom,
            x: x,
            y: y
          }
        });
        progress += 1;
        setProgress(progress);
      }
      refetchTreeSegmentation();
    })();
  }, [unsegmentedTiles]);

  return (
    <Modal
      size="lg"
      show={taskModalDialogVisible}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>Processing</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={4}>Tree segmentation</Col>
          <Col>
            <ProgressBar now={progress} min={0} max={maxProgress} />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
};

TaskModal.propTypes = {
  refetchTreeSegmentation: PropTypes.func.isRequired
};

export default TaskModal;
